<template>
  <div class="problem"><div class="inner" @click="editProblem" title="View Details">
    <span v-if="problem.priority.value !== null" :title="problem.priority.longLabel"><img class="priority" :src="'/static/images/priority/' + problem.priority.value + '.png'"/></span>
    <!-- <span :title="problem.status.longLabel" :class="'status status-' + problem.status.value "></span> -->
    <button v-if="hasNotBeenAccepted && canedit" class="'btn creation" @click.stop="accept">Accept</button>
    <div class="school" v-if="problem.school"> {{ problem.school.shortLabel }} </div>
    <div class="location-detail">
      <span v-if="problem.floorType.value">{{ problem.floorType.shortLabel }} </span>
      <span v-if="problem.roomType.value">{{ problem.roomType.shortLabel }} </span>
      <span v-if="problem.roomName">{{ problem.roomName }} </span>
      <span v-if="problem.roomNumber">{{ problem.roomNumber }} </span>
    </div>
    
    <div class="info" v-if="dateReported"><span title="Problem reported" class="status status-0">&nbsp;</span> Reported</div>    
    <div class="last-action" v-if="dateReported">&nbsp;&nbsp;{{ dateReported }}</div>

    <div class="info"><span :title="problem.status.longLabel" :class="'status status-' + problem.status.value ">&nbsp;</span> {{ problem.status.shortLabel }}</div>    
    <div class="last-action" v-if="problem.status.lastModifiedDate">&nbsp;&nbsp;{{ dateCreated }}</div>

    <div class="prob-type"><span :class="'prob-tag prob-bg-' + problem.problemType.value">{{ problem.problemType.shortLabel }}</span></div>
    <div class="images" v-if="problem.images.length > 0">
      <img v-for="image in problem.images" v-bind:key="image['.storageName']" src="/static/images/image-100.png" @click.stop="selectImage(image)" />
    </div>
    <div class="no-images" v-else><span>No images provided</span></div>
    <div class="info" v-if="problem.description">
      <h5>Additional Information</h5>
      <p>{{ problem.description }}</p>
    </div>
  </div>
  </div>
</template>

<script>
  import database from '@/api/database.js'
  import { parse, format, differenceInDays, distanceInWordsStrict, differenceInHours } from 'date-fns'
  export default {
    name: 'NewProblemView',
    props: {
      problem: Object,
      canedit: Boolean
    },
    data() {
      return {
      }
    },
    computed: {
      dateCreated () {
        const created = parse(this.problem.status.lastModified)
        return this.composeDatePhrase(created)      
      },
      dateReported () {
        if (this.problem.status.value === 0 ) {
          return undefined
        }
        let reportedStatus = undefined
        if (this.problem.statusHistory) {
          reportedStatus = this.problem.statusHistory.find(s => s.value === 0)
        }
        if (!reportedStatus) {
          return undefined
        }
        const reported = parse(reportedStatus.lastModified)
        return this.composeDatePhrase(reported)
      },
      hasNotBeenAccepted () {
        var has = false
        has = this.problem.status.value === 2
        if (!has) {
          const accepted = this.problem.statusHistory.find(status => status.value === 2)
          if (accepted) {
            has = true
          }
        }
        return !has
      }
    },
    methods: {
      composeDatePhrase (then) {
        const now = new Date()
        const daysDiff = differenceInDays(then, now)
        const hoursDiff = differenceInHours(then, now)
        var dateTextThen = format(then, 'ddd MMM D')
        var timeTextThen = format(then, 'h:mm a')
        var words = distanceInWordsStrict(then, now)
        var phrase = ''
        if (daysDiff === -1) {
          phrase = hoursDiff * -1 + ' hours ago'
        } else {
          phrase = words + ' ago'
        }
        if (daysDiff < 0) {
          phrase += ', ' + dateTextThen
        }
        return phrase + ' at ' + timeTextThen
      },
      selectImage (img) {
        this.$emit('imagePicked', img)
      },
      editProblem () {
        this.$emit('editProblem', this.problem)
      },
      async accept () {
        await database.accept(this.problem)
        this.$emit('updated', this.problem)
      }
    }
  }
</script>

<style scoped>
.priority {
  height: 13px;
  width: 13px;
  position: absolute;
  top: 8px;
  right: 8px;
}
.problemType {
  margin-bottom: 25px;
}
.problemType:last-child {
  margin: 0;
}

.prob-badge {
  display: block;
  height: 3px;
}
.problem .inner {
  background: hsla(0, 0%, 94%, 1);
  padding: 15px;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
  position: relative;
}
.problem .inner:hover {
  background: hsla(0, 0%, 84%, 1);
  cursor: pointer;
}

.problem .last-action {
  color: rgb(123, 143, 155);
}
.edit {
  float:right;
}
.problemType h3,
.problem .last-action,
.problem .prob-type,
.images,
.no-images {
  margin: 0 0 8px;
}
.problem .location-detail {
  color: rgb(123, 143, 155);
  margin-bottom: 4px;
}

.problem .school {
  font-weight: 500;
  color: #242424;
  font-size: 1rem;
}
.images {
  height: 38px;
  overflow: hidden;
  text-align: left;
}

.images img {
  max-height: 34px;
  margin-right: 5px;
  border: 2px solid white;
  cursor: pointer;
}
.no-images {
  height: 34px;
  border: 2px solid white;
  background: #ddd;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
  font-size: 0.5rem;
}
.no-images span {
  display: inline-block;
  padding: 10px;
}
.info h5 {
  margin: 0 0 2px;
} 
.info p {
  margin: 0;
  color: #333;
  font-size: 0.75rem;
}
.status {
  /* position: absolute;
  top: 10px;
  right: 10px;
  width: 45px;
  height: 10px; */
  border-radius: 5px;
  cursor: pointer;
}

button {
  position: absolute;
  top: 25px;
  right: 8px;
}
</style>